import React from 'react';

import cs from 'classnames';

export interface FormItemProps {
  label: string | JSX.Element;
  helpText?: string | JSX.Element;
  id: string;
  labelClass?: string;
  children: JSX.Element;
}

export function FormItem({
  id,
  label,
  labelClass,
  helpText,
  children,
}: FormItemProps) {
  return (
    <div className="form-group row">
      <label
        htmlFor={id}
        className={cs('col-form-label', labelClass, {
          'col-xl-2 col-lg-3 col-md-3 col-sm-4': labelClass == null,
        })}
      >
        {label}
        {helpText ? (
          <div>
            <span className="text-secondary small">{helpText}</span>
          </div>
        ) : null}
      </label>
      {children}
    </div>
  );
}
